module.exports = __webpack_public_path__ + "static/media/purple-checkmark.63a51f14.svg";